export const ingredients = [
  {
    image: '🍎',
    name: 'Apple',
  },
  {
    image: '🥑',
    name: 'Avocado',
  },
  {
    image: '🥦',
    name: 'Broccoli',
  },
  {
    image: '🥕',
    name: 'Carrot',
  },
  {
    image: '🍷',
    name: 'Red wine dressing',
  },
  {
    image: '🍚',
    name: 'Seasoned rice',
  },
];